import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';

import { BehaviorSubject, of } from 'rxjs';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Portals } from '@qwyk/models';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs/operators';

import { QuotationsService } from '../../services/quotations.service';
import { QuotationNetworkRateRequestComponent } from '../quotation-network-rate-request/quotation-network-rate-request.component';

@Component({
    selector: 'qwyk-quotation-network-info',
    templateUrl: './quotation-network-info.component.html',
    styleUrls: ['./quotation-network-info.component.scss'],
    providers: [DialogService]
})
export class QuotationNetworkInfoComponent implements OnInit, OnDestroy {

    private modal = inject(DialogService);
    private service = inject(QuotationsService);

    @Input() quotation: Portals.QuotationEntity;

    public ref: DynamicDialogRef | undefined;
    public loadNetworkQuotation$: BehaviorSubject<Portals.QuotationEntity> =
        new BehaviorSubject<Portals.QuotationEntity>(null);
    public error = false;
    public networkQuotation$ = this.loadNetworkQuotation$.pipe(
        tap(() => console.log('he!')),
        filter(input => input !== null),
        switchMap(quotation =>
            this.service.getNetworkQuotationInfo(quotation).pipe(
                take(1),
                catchError(error => {
                    this.error = true;
                    console.error(error);
                    return of(null);
                })
            )
        )
    );

    ngOnInit(): void {
        this.loadNetworkQuotation$.next(this.quotation);
    }

    public onMakeRequest() {
        this.ref = this.modal.open(QuotationNetworkRateRequestComponent, {
            showHeader: false,
            closable: true,
            width: '75%',
            position: 'center',
            contentStyle: {
                'padding': 0
            }
        });

        this.ref.onClose.subscribe((request) => {
            if (request) {
                this.service
                    .createNetworkQuotationRequest(this.quotation, request)
                    .pipe(
                        take(1),
                        map(() => true),
                        catchError(error => {
                            console.error(error);
                            return of(null);
                        })
                    )
                    .subscribe(result => {
                        if (result) {
                            this.loadNetworkQuotation$.next(this.quotation);
                        }
                    });
            }
        });
    }

    ngOnDestroy() {
        if (this.ref) {
            this.ref.close();
        }
    }
}
